function toggleFlex(element) {
  element.classList.toggle('hidden');
  element.classList.toggle('flex');
}

document.addEventListener('DOMContentLoaded', function () {
  if(document.querySelector(".btn--mute")){
    for (let i = 0; i < document.querySelectorAll(".video-banner").length; i++) {
      let videoBanner = document.querySelectorAll(".video-banner")[i];
      document.querySelectorAll(".btn--mute")[i].addEventListener('click', function(event) {
        toggleFlex(event.target.children[0])
        if (videoBanner){
          if (videoBanner.muted == true) {
            videoBanner.muted = false;
            videoBanner.volume = .2;
          } else {
            videoBanner.muted = true;
          }
        }
      });
      document.querySelectorAll(".btn--play")[i].addEventListener('click', function(event) {
        if (videoBanner){
          if (videoBanner.paused) {
            videoBanner.play()
            toggleFlex(event.target.children[0])
            toggleFlex(event.target.children[1])
          } else {
            videoBanner.pause()
            toggleFlex(event.target.children[0])
            toggleFlex(event.target.children[1])
          }
        }
      });
  
      document.querySelectorAll(".btn--fullscreen")[i].addEventListener('click', () => {
        if (videoBanner.webkitEnterFullscreen) {
          // iOS Safari
          videoBanner.webkitEnterFullscreen();
        } else if (videoBanner.requestFullscreen) {
          // Standard Fullscreen API
          videoBanner.requestFullscreen();
        } else if (videoBanner.webkitRequestFullscreen) {
          // Safari Desktop
          videoBanner.webkitRequestFullscreen();
        } else if (videoBanner.mozRequestFullScreen) {
          // Firefox
          videoBanner.mozRequestFullScreen();
        } else if (videoBanner.msRequestFullscreen) {
          // IE/Edge
          videoBanner.msRequestFullscreen();
        } 
      });
  
      // Exit fullscreen if ESC key is pressed or fullscreen is closed
      document.addEventListener('fullscreenchange', () => {
        if (!document.fullscreenElement) {
          console.log("Exited fullscreen mode.");
        }
      });
    }

    const videoContainer = document.getElementById('videoBanner');
    if (videoContainer) {
      const videos = videoContainer ? videoContainer.querySelectorAll('video') : [];
      videos.forEach(video => {
        // Try to play the video manually
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            // Optional: fallback or debug logging
            console.warn('Autoplay failed:', error);
          });
        }
      });
    }
  }
});
